import { WSEmptyStateProps } from "@wingspanhq/fe-component-library/dist/lib/components/WSEmptyState/WSEmptyState";
import {
  SignatureRequest,
  SignatureRequestStatus
} from "@wingspanhq/wingspan-api-sdk";

import { mapStatusesToCardDetails } from "../../../../helpers/mapStatusesToCardDetails";
import { RequirementTableItemData } from "../../../../types";

export const payeeSignatureRenderCardDescription = (
  requirement: RequirementTableItemData,
  signatureRequest?: SignatureRequest
) => {
  const signatureRequestDescriptions: Record<
    SignatureRequestStatus,
    WSEmptyStateProps
  > = {
    [SignatureRequestStatus.NEW]: {
      type: "documents",
      title: "Document sent for signature",
      description:
        "The document has been delivered to the contractor for their signature."
    },
    [SignatureRequestStatus.AWAITING_SIGNATURE]: {
      type: "documents",
      title: "Document sent for signature",
      description:
        "The document has been delivered to the contractor for their signature."
    },
    [SignatureRequestStatus.AWAITING_COUNTERSIGNATURE]: {
      type: "documents",
      title: "Document requires countersignature",
      description:
        "The contractor has signed the document. Please review and countersign to complete the process."
    },
    [SignatureRequestStatus.COMPLETED]: {
      type: "done",
      title: "The e-signature document is complete",
      description:
        "All signatures have been collected. The fully executed document is available for download."
    }
  };

  return mapStatusesToCardDetails({
    requirement,
    documentStatus:
      signatureRequest?.status ?? SignatureRequestStatus.AWAITING_SIGNATURE,
    documentStatuses: signatureRequestDescriptions,
    pendingApprovalStatus: {
      type: "documents",
      title: "Document pending your approval",
      description:
        "All signatures have been collected. The requirement now requires your approval or rejection."
    },
    approvedStatus: null,
    rejectedStatus: {
      type: "documents",
      title: "Document was rejected",
      description:
        "The requirement was rejected and may affect the contractor’s eligibility for related engagements."
    }
  });
};
